export default __webpack_public_path__ + "static/team-3-83e686f57ba26fd3bdea71f558049152.jpg";